import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useCustomerStore } from '@stores/customer'

import { useCustomerDetailsApi } from '@api/customer/details.hook'
import { useCustomerPrivileges } from '@hooks/customer/customer-privileges.hook'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * `customers.details` needs view-customers; without it the page is built from `customers.show`
 * (loaded by `customer-show`), as the legacy page did for simple viewers.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const customerId = to.params.id

  if (typeof customerId !== 'string' || !customerId) return

  const customerStore = useCustomerStore()

  if (customerStore.getDetails?.id !== Number(customerId)) {
    customerStore.resetDetails()
  }

  const { canViewCustomers } = useCustomerPrivileges()

  if (canViewCustomers.value) {
    void useCustomerDetailsApi({ customerId })
  }
})
